import type { KnownLegacyError } from "_shared/_errors/api-error";

const reviewedLegacyDocumentMessages = ["Bad file", "Only PDF files are allowed"] as const;

/**
 * TODO(#4907): Remove this exact-text migration adapter and its callers after the Documents API
 * migration subtask emits only the v1 Problem Details profile.
 */
export const knownLegacyDocumentErrors: Readonly<Record<string, KnownLegacyError>> = Object.fromEntries(
  reviewedLegacyDocumentMessages.map((detail) => [
    detail,
    { code: "unsupported_document_type", title: "Unsupported file type", detail },
  ]),
);
